import { render, staticRenderFns } from "./SearchTreeItem.vue?vue&type=template&id=2fe538ac&"
import script from "./SearchTreeItem.vue?vue&type=script&lang=ts&"
export * from "./SearchTreeItem.vue?vue&type=script&lang=ts&"
import style0 from "./SearchTreeItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports